var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('div',{staticStyle:{"height":"1px","width":"100%","background":"#ccc","margin":"5px 0"}})])])
}]

export { render, staticRenderFns }